import { render } from "./FemaleUsersPage.vue?vue&type=template&id=1227c2d0&scoped=true"
import script from "./FemaleUsersPage.vue?vue&type=script&lang=js"
export * from "./FemaleUsersPage.vue?vue&type=script&lang=js"

import "./FemaleUsersPage.vue?vue&type=style&index=0&id=1227c2d0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1227c2d0"

export default script